import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import { ErrorMessages } from '../../../../model/error';
import { SignatureAreaError } from './signature-area-types';

export const messagesForSignatureAreaError = (
  error: SignatureAreaError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};
